import { INGREDIENTS_IMAGES, PRODUCT_IMAGES } from "../utils/imagesMap"

import pdpEditorialImagePostpartum from "../images/fb-editorial-postpartum.jpg"
import pdpEditorialImageBalance from "../images/fb-editorial-balance.jpg"
import pdpEditorialImageWomen from "../images/fb-editorial-women.jpg"
import pdpEditorialImageMen from "../images/fb-editorial-men.jpg"
import pdpEditorialImageVegan from "../images/fb-editorial-vegan.jpg"

export const Women = {
  core: "Women",
  dropdownImg: PRODUCT_IMAGES.WOM1.label1,
  name: "Women",
  info: "For women 18-44",
  complex: {
    title: "Synergen Complex&reg;",
    list: [
      {
        name: "Sensoril&reg; Ashwagandha",
        image: INGREDIENTS_IMAGES.ASHWAGANDHA,
        target: "Anti Shedding",
        items: [
          {
            title: "What It Is",
            text: "An adaptogen that helps balance stress hormones to support a healthy hair growth cycle.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Exclusive to Nutrafol, Sensoril® Ashwagandha is wild-harvested in India using sustainable practices and a double-patented clean extraction method. Sensoril® is the highest quality Ashwagandha available in a hair supplement. While most Ashwagandha extracts come from the root of the plant, ours is extracted from the root and leaves for a higher concentration of actives that absorbs more quickly and easily into the body.",
          },
          {
            title: "The Research",
            text: "More than 12 clinical trials have shown proven benefits for stress relief, immune support, sleep quality, fatigue, and energy.",
          },
        ],
      },
      {
        name: "Saw Palmetto",
        image: INGREDIENTS_IMAGES.SAW_PALMETTO,
        target: "Anti-DHT",
        items: [
          {
            title: "What It Is",
            text: "Saw Palmetto promotes hair growth by helping reduce DHT, a hormone that shrinks hair follicles and leads to progressive hair thinning.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Our Saw Palmetto is responsibly harvested in the USA and extracted through a non-toxic, high-pressure process for the highest concentration of plant actives in each batch. The extract delivers efficacy to areas of the body like the scalp to help improve hair growth.",
          },
          {
            title: "The Research",
            text: "Our Saw Palmetto has been shown in over 25 clinical trials to improve urinary tract health and support hair health.",
          },
        ],
      },
      {
        name: "Tocotrienol Complex",
        image: INGREDIENTS_IMAGES.TOCOTRIENOL,
        target: "Densifying",
        items: [
          {
            title: "What It Is",
            text: "This concentrated form of the antioxidant vitamin E helps minimize the effects of environmental stress to improve hair density.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sourced from sustainably grown palm trees in Malaysia, our oil is extracted from palm seeds, then optimized for superior absorption in the body.",
          },
          {
            title: "The Research",
            text: "With over 20 years of research, this is the only Tocotrienol Extract that’s clinically proven for hair growth.",
          },
        ],
      },
      {
        name: "Marine Collagen Peptides",
        image: INGREDIENTS_IMAGES.MARINE_COLLAGEN,
        target: "Strengthening",
        items: [
          {
            title: "What It Is",
            text: "Peptides provide the building blocks of strong hair and deliver moisture to the scalp.",
          },
          {
            title: "What Sets Ours Apart",
            text: `Our Marine Collagen Peptides are sustainably sourced from wild-caught fish that live in the cleanest ocean waters of the North Atlantic, then upcycled from the scales of the fish.
            They are processed to be a specific size that the body can absorb quickly and use immediately to support healthy hair.`,
          },
          {
            title: "The Research",
            text: "Clinical studies have shown that improved bioactivity of collagen increases collagen stores in the body for healthy hair and skin support.",
          },
        ],
      },
      {
        name: "Curcumin",
        image: INGREDIENTS_IMAGES.CURCUMIN,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "An active ingredient found in turmeric, this supercharged antioxidant addresses multiple root causes of hair thinning and is 500x more potent than turmeric alone.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Traditionally and organically harvested to minimize environmental waste. We use a patented extraction method that extends the length of Curcumin’s bioactivity in the body, which allows it time to effectively target root causes of hair thinning.",
          },
          {
            title: "The Research",
            text: "Proven in over 28 clinical studies to benefit multiple systems in the body that affect the cellular response needed for hair growth.",
          },
        ],
      },
    ],
  },
  keyActives: {
    title: "Other Key Actives",
    list: [
      {
        name: "Kelp Minerals",
        image: INGREDIENTS_IMAGES.KELP,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "A sea vegetable that supports key hormones needed to promote a healthy metabolism for hair health.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Wild-harvested from organic seaweed beds found in the pristine waters surrounding Iceland. This kelp is naturally rich in minerals that come from geothermal vents in the ocean floor. We slowly dry the kelp to protect iodine’s bioavailability.",
          },
          {
            title: "The Research",
            text: "Clinically shown to provide minerals essential to hair growth.",
          },
        ],
      },
      {
        name: "Resveratrol",
        image: INGREDIENTS_IMAGES.RESVERATROL,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "Typically found in red wine, this powerful antioxidant promotes hair density by protecting the scalp from environmental damage. Ours is a bioavailable form derived from Japanese Knotweed.",
          },
        ],
      },
      {
        name: "Horsetail",
        image: INGREDIENTS_IMAGES.HORSETAIL,
        target: "Anti-breakage",
        items: [
          {
            title: "What It Is",
            text: "A natural source of silica, an essential mineral that promotes hair strength.",
          },
        ],
      },
      {
        name: "Keratin",
        image: INGREDIENTS_IMAGES.KERATIN,
        target: "Strengthening",
        items: [
          {
            title: "What It Is",
            text: "A protein that creates the structure for hair, skin, and nails. Our ingredient mimics keratin in the body to support damaged hair.",
          },
        ],
      },
    ],
  },
  editorial: {
    verticalSpacing: ["64px", "80px", "128px"],
    mobilePadding: "66.66%",
    image: pdpEditorialImageWomen,
    imageTablet: pdpEditorialImageWomen,
    imageMobile: pdpEditorialImageWomen,
    slides: [
      {
        abbreviation: "Sp",
        icon: INGREDIENTS_IMAGES.ASHWAGANDHA,
        title: "Sensoril&reg; Ashwagandha",
        text: "Balances stress hormones to support the hair growth cycle.<sup>5</sup>",
      },
      {
        abbreviation: "Tc",
        icon: INGREDIENTS_IMAGES.TOCOTRIENOL,
        title: "Tocotrienol Complex",
        text: "Improves hair density by lowering oxidative stress from the environment.<sup>6</sup>",
      },
      {
        abbreviation: "Sa",
        title: "Marine Collagen",
        icon: INGREDIENTS_IMAGES.MARINE_COLLAGEN,
        text: "Provides amino acids as building blocks of hair-strengthening keratin.<sup>7</sup>",
      },
    ],
    button: {
      label: "See all 21 ingredients",
      destination: `/ingredients/`,
      isTextLink: true,
      module_location: "bottom_fold",
    },
  },
  ingredients: {
    title: "Supporting Ingredients",
    list: [
      "L-Cysteine",
      "L-Lysine",
      "L-Methionine",
      "Black Pepper",
      "Capsicum",
      "Vitamin A",
      "Vitamin C",
      "Vitamin D",
      "Biotin ",
      "Zinc",
      "Selenium",
      "Hyaluronic Acid",
    ],
  },
}

export const Vegan = {
  core: "Women's Vegan",
  dropdownImg: PRODUCT_IMAGES.VEG1.label1,
  name: "Women's Vegan",
  info: "For women 18-44",
  complex: {
    title: "Synergen Plant Complex &reg;",
    list: [
      {
        name: "Sensoril&reg; Ashwagandha",
        image: INGREDIENTS_IMAGES.ASHWAGANDHA,
        target: "Anti Shedding",
        items: [
          {
            title: "What It Is",
            text: "An adaptogen that helps balance stress hormones to support a healthy hair growth cycle.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Exclusive to Nutrafol, Sensoril® Ashwagandha is wild-harvested in India using sustainable practices and a double-patented clean extraction method. Sensoril® is the highest quality Ashwagandha available in a hair supplement. While most Ashwagandha extracts come from the root of the plant, ours is extracted from the root and leaves for a higher concentration of actives that absorbs more quickly and easily into the body.",
          },
          {
            title: "The Research",
            text: "More than 12 clinical trials have shown proven benefits for stress relief, immune support, sleep quality, fatigue, and energy.",
          },
        ],
      },
      {
        name: "Moldavian Dragonhead",
        image: INGREDIENTS_IMAGES.DRAGONHEAD,
        target: "Strengthening",
        items: [
          {
            title: "What It Is",
            text: "Moldavian Dragonhead is a plant extract clinically shown to promote natural collagen production in the body.",
          },
        ],
      },
      {
        name: "Tocotrienol Complex",
        image: INGREDIENTS_IMAGES.TOCOTRIENOL,
        target: "Densifying",
        items: [
          {
            title: "What It Is",
            text: "This concentrated form of the antioxidant vitamin E helps minimize the effects of environmental stress to improve hair density.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sourced from sustainably grown palm trees in Malaysia, our oil is extracted from palm seeds, then optimized for superior absorption in the body.",
          },
          {
            title: "The Research",
            text: "With over 20 years of research, this is the only Tocotrienol Extract that’s clinically proven for hair growth.",
          },
        ],
      },
      {
        name: "Curcumin",
        image: INGREDIENTS_IMAGES.CURCUMIN,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "An active ingredient found in turmeric, this supercharged antioxidant addresses multiple root causes of hair thinning and is 500x more potent than turmeric alone.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Traditionally and organically harvested to minimize environmental waste. We use a patented extraction method that extends the length of Curcumin’s bioactivity in the body, which allows it time to effectively target root causes of hair thinning.",
          },
          {
            title: "The Research",
            text: "Proven in over 28 clinical studies to benefit multiple systems in the body that affect the cellular response needed for hair growth.",
          },
        ],
      },
      {
        name: "Saw Palmetto",
        image: INGREDIENTS_IMAGES.SAW_PALMETTO,
        target: "Anti-DHT",
        items: [
          {
            title: "What It Is",
            text: "Saw Palmetto promotes hair growth by helping reduce DHT, a hormone that shrinks hair follicles and leads to progressive hair thinning.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Our Saw Palmetto is responsibly harvested in the USA and extracted through a non-toxic, high-pressure process for the highest concentration of plant actives in each batch. The extract delivers efficacy to areas of the body like the scalp to help improve hair growth.",
          },
          {
            title: "The Research",
            text: "Our Saw Palmetto has been shown in over 25 clinical trials to improve urinary tract health and support hair health.",
          },
        ],
      },
    ],
  },
  keyActives: {
    title: "Other Key Actives",
    list: [
      {
        name: "Pea Sprouts",
        image: INGREDIENTS_IMAGES.PEA_SPROUT,
        target: "",
        items: [
          {
            title: "What It Is",
            text: "A concentrated extract from pea sprouts shown to improve hair growth.",
          },
        ],
      },
      {
        name: "Bacillus subtilis DE111&reg; Probiotic",
        image: INGREDIENTS_IMAGES.BACILLUS,
        target: "",
        items: [
          {
            title: "What It Is",
            text: "Optimizes the microbiome and helps with the breakdown and absorption of nutrients.",
          },
        ],
      },
    ],
  },
  editorial: {
    verticalSpacing: ["64px", "80px", "128px"],
    mobilePadding: "66.66%",
    image: pdpEditorialImageVegan,
    imageTablet: pdpEditorialImageVegan,
    imageMobile: pdpEditorialImageVegan,
    slides: [
      {
        abbreviation: "Dh",
        icon: INGREDIENTS_IMAGES.DRAGONHEAD,
        title: "Moldavian Dragonhead",
        text: "Promotes natural collagen production in the body.<sup>15</sup>",
      },
      {
        abbreviation: "Sa",
        icon: INGREDIENTS_IMAGES.ASHWAGANDHA,
        title: "Sensoril&reg; Ashwagandha",
        text: "Balances stress hormones to support the hair growth cycle.<sup>1</sup>",
      },
      {
        abbreviation: "Tc",
        title: "Tocotrienol Complex",
        icon: INGREDIENTS_IMAGES.TOCOTRIENOL,
        text: "Improves hair density by lowering oxidative stress from the environment.<sup>6</sup>",
      },
    ],
    button: {
      label: "See all 21 ingredients",
      destination: `/ingredients/`,
      isTextLink: true,
      module_location: "bottom_fold",
    },
  },
  ingredients: {
    title: "Supporting Ingredients",
    list: [
      "Vitamin A",
      "Vitamin B12",
      "Vitamin C",
      "Vitamin D (from Algae)",
      "Kelp (Iodine)",
      "Selenium",
      "Zinc",
      "Vitamin K2",
      "Capsicum",
      "Bamboo",
      "Beet Root",
      "Chlorella",
    ],
  },
}

export const Balance = {
  core: "Women's Balance",
  dropdownImg: PRODUCT_IMAGES.BAL1.label1,
  name: "Women's Balance",
  info: "For women 45+",
  complex: {
    title: "Synergen Complex Plus&reg;",
    list: [
      {
        name: "Sensoril&reg; Ashwagandha",
        image: INGREDIENTS_IMAGES.ASHWAGANDHA,
        target: "Anti Shedding",
        items: [
          {
            title: "What It Is",
            text: "An adaptogen that helps balance stress hormones to support a healthy hair growth cycle.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Exclusive to Nutrafol, Sensoril® Ashwagandha is wild-harvested in India using sustainable practices and a double-patented clean extraction method. Sensoril® is the highest quality Ashwagandha available in a hair supplement. While most Ashwagandha extracts come from the root of the plant, ours is extracted from the root and leaves for a higher concentration of actives that absorbs more quickly and easily into the body.",
          },
          {
            title: "The Research",
            text: "More than 12 clinical trials have shown proven benefits for stress relief, immune support, sleep quality, fatigue, and energy.",
          },
        ],
      },
      {
        name: "Saw Palmetto",
        image: INGREDIENTS_IMAGES.SAW_PALMETTO,
        target: "Anti-DHT",
        items: [
          {
            title: "What It Is",
            text: "Saw Palmetto promotes hair growth by helping reduce DHT, a hormone that shrinks hair follicles and leads to progressive hair thinning.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Our Saw Palmetto is responsibly harvested in the USA and extracted through a non-toxic, high-pressure process for the highest concentration of plant actives in each batch. The extract delivers efficacy to areas of the body like the scalp to help improve hair growth.",
          },
          {
            title: "The Research",
            text: "Our Saw Palmetto has been shown in over 25 clinical trials to improve urinary tract health and support hair health.",
          },
        ],
      },
      {
        name: "Tocotrienol Complex",
        image: INGREDIENTS_IMAGES.TOCOTRIENOL,
        target: "Densifying",
        items: [
          {
            title: "What It Is",
            text: "This concentrated form of the antioxidant vitamin E helps minimize the effects of environmental stress to improve hair density.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sourced from sustainably grown palm trees in Malaysia, our oil is extracted from palm seeds, then optimized for superior absorption in the body.",
          },
          {
            title: "The Research",
            text: "With over 20 years of research, this is the only Tocotrienol Extract that’s clinically proven for hair growth.",
          },
        ],
      },
      {
        name: "Marine Collagen Peptides",
        image: INGREDIENTS_IMAGES.MARINE_COLLAGEN,
        target: "Strengthening",
        items: [
          {
            title: "What It Is",
            text: "Peptides provide the building blocks of strong hair and deliver moisture to the scalp.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sustainably sourced from wild-caught fish that live in the cleanest ocean waters of the North Atlantic, then upcycled from the scales of the fish. Our Marine Collagen Peptides are processed to be a specific size that the body can absorb quickly and use immediately to support healthy hair.",
          },
          {
            title: "The Research",
            text: "Clinical studies have shown that improved bioactivity of collagen increases collagen stores in the body for healthy hair and skin support.",
          },
        ],
      },
      {
        name: "Curcumin",
        image: INGREDIENTS_IMAGES.CURCUMIN,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "An active ingredient found in turmeric, this supercharged antioxidant addresses multiple root causes of hair thinning and is 500x more potent than turmeric alone.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Traditionally and organically harvested to minimize environmental waste. We use a patented extraction method that extends the length of Curcumin’s bioactivity in the body, which allows it time to effectively target root causes of hair thinning.",
          },
          {
            title: "The Research",
            text: "Proven in over 28 clinical studies to benefit multiple systems in the body that affect the cellular response needed for hair growth.",
          },
        ],
      },
      {
        name: "Maca",
        image: INGREDIENTS_IMAGES.MACA,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "Provides hormonal support through peri- and postmenopause and helps block DHT, a hormone that shrinks hair follicles and leads to progressive hair thinning.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sustainably grown in the mountains of Peru and harvested only once a year to minimize environmental impact. The Maca root is organically processed into an ingestible form that supports hormonal balance.",
          },
          {
            title: "The Research",
            text: "The only species of Maca that has been clinically proven to support women before, during, and after menopause.",
          },
        ],
      },
      {
        name: "Astaxanthin",
        image: INGREDIENTS_IMAGES.ASTAXANTHIN,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "Found in algae, this powerful antioxidant supports age-related changes in the skin by energizing the cells needed for a healthy hair growth cycle.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sourced in the Himalayan mountains and harvested from microalgae raised in glass tubes to prevent contamination. Our natural extraction process delivers the highest concentration of Astaxanthin for superior antioxidant activity that is 600 times stronger than vitamin C.",
          },
          {
            title: "The Research",
            text: "Proven in over 40 clinical studies to support cellular health and contain anti-aging benefits.",
          },
        ],
      },
    ],
  },
  keyActives: {
    title: "Other Key Actives",
    list: [
      {
        name: "Kelp Minerals",
        image: INGREDIENTS_IMAGES.KELP,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "A sea vegetable that supports key hormones needed to promote a healthy metabolism for hair health.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Wild-harvested from organic seaweed beds found in the pristine waters surrounding Iceland. This kelp is naturally rich in minerals that come from geothermal vents in the ocean floor. We slowly dry the kelp to protect iodine’s bioavailability.",
          },
          {
            title: "The Research",
            text: "Clinically shown to provide minerals essential to hair growth.",
          },
        ],
      },
      {
        name: "Resveratrol",
        image: INGREDIENTS_IMAGES.RESVERATROL,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "Typically found in red wine, this powerful antioxidant promotes hair density by protecting the scalp from environmental damage. Ours is a bioavailable form derived from Japanese Knotweed.",
          },
        ],
      },
      {
        name: "Horsetail",
        image: INGREDIENTS_IMAGES.HORSETAIL,
        target: "Anti-breakage",
        items: [
          {
            title: "What It Is",
            text: "A natural source of silica, an essential mineral that promotes hair strength.",
          },
        ],
      },
    ],
  },
  editorial: {
    verticalSpacing: ["64px", "80px", "128px"],
    mobilePadding: "66.66%",
    image: pdpEditorialImageBalance,
    imageTablet: pdpEditorialImageBalance,
    imageMobile: pdpEditorialImageBalance,
    slides: [
      {
        abbreviation: "Tc",
        icon: INGREDIENTS_IMAGES.MACA,
        title: "Maca",
        text: "Adaptogen known to support hormone health before, during, and after menopause.<sup>8</sup>",
      },
      {
        abbreviation: "Sp",
        icon: INGREDIENTS_IMAGES.SAW_PALMETTO,
        title: "Saw Palmetto",
        text: "Combats thinning hair by helping prevent testosterone conversion to DHT.<sup>9</sup>",
      },

      {
        abbreviation: "Sa",
        title: "Sensoril&reg; Ashwagandha",
        icon: INGREDIENTS_IMAGES.ASHWAGANDHA,
        text: "Balances stress hormones to support the hair growth cycle.<sup>5</sup>",
      },
    ],
    button: {
      label: "See all 21 ingredients",
      destination: `/ingredients/`,
      isTextLink: true,
      module_location: "bottom_fold",
    },
  },
  ingredients: {
    title: "Supporting Ingredients",
    list: [
      "L-Cysteine",
      "L-Lysine",
      "L-Methionine",
      "Black Pepper",
      "Capsicum",
      "Vitamin A",
      "Vitamin C",
      "Vitamin D",
      "Biotin ",
      "Zinc",
      "Selenium",
    ],
  },
}

export const Postpartum = {
  core: "Postpartum",
  dropdownImg: PRODUCT_IMAGES.POS1.label1,
  name: "Postpartum",
  info: null,
  complex: {
    title: "Synergen Complex Recovery&reg;",
    list: [
      {
        name: "Marine Collagen Peptides",
        image: INGREDIENTS_IMAGES.MARINE_COLLAGEN,
        target: "Strengthening",
        items: [
          {
            title: "What It Is",
            text: "Peptides provide the building blocks of strong hair and deliver moisture to the scalp.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sustainably sourced from wild-caught fish that live in the cleanest ocean waters of the North Atlantic, then upcycled from the scales of the fish. Our Marine Collagen Peptides are processed to be a specific size that the body can absorb quickly and use immediately to support healthy hair.",
          },
          {
            title: "The Research",
            text: "Clinical studies have shown that improved bioactivity of collagen increases collagen stores in the body for healthy hair and skin support.",
          },
        ],
      },
      {
        name: "Shatavari",
        image: INGREDIENTS_IMAGES.SHATAVARI,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "An adaptogen that targets physical and emotional stress to help balance the body for a healthy hair growth cycle.",
          },
        ],
      },
      {
        name: "DHA Omega-3s",
        image: INGREDIENTS_IMAGES.OMEGAS,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "Found in algae, these fatty acids help the body recover from physical stress to promote healthy hair.",
          },
        ],
      },
      {
        name: "Apple Polyphenols",
        image: INGREDIENTS_IMAGES.APPLE,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "An antioxidant-rich extract from apple skins that promotes hair growth by supporting cellular health.",
          },
        ],
      },
      {
        name: "Tocotrienol Complex",
        image: INGREDIENTS_IMAGES.TOCOTRIENOL,
        target: "Densifying",
        items: [
          {
            title: "What It Is",
            text: "This concentrated form of the antioxidant vitamin E helps minimize the effects of environmental stress to improve hair density.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sourced from sustainably grown palm trees in Malaysia, our oil is extracted from palm seeds, then optimized for superior absorption in the body.",
          },
          {
            title: "The Research",
            text: "With over 20 years of research, this is the only Tocotrienol Extract that’s clinically proven for hair growth.",
          },
        ],
      },
      {
        name: "Stinging Nettle",
        image: INGREDIENTS_IMAGES.NETTLE,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "A plant rich in minerals to restore essential nutrients while enhancing other ingredients for better efficacy.",
          },
        ],
      },
      {
        name: "Collagen-OSA",
        image: INGREDIENTS_IMAGES.COLLAGEN_OSA,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "A source of orthosilicic acid, a potent mineral that supports hair strength and thickness by delivering nutrients to the hair shaft.",
          },
        ],
      },
      {
        name: "Theanine",
        image: INGREDIENTS_IMAGES.THEANINE,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "An amino acid that promotes relaxation by supporting the body’s response to emotional stress.",
          },
        ],
      },
    ],
  },
  keyActives: {
    title: "Other Key Actives",
    list: [
      {
        name: "Kelp Minerals",
        image: INGREDIENTS_IMAGES.KELP,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "A sea vegetable that supports key hormones needed to promote a healthy metabolism for hair health.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Wild-harvested from organic seaweed beds found in the pristine waters surrounding Iceland. This kelp is naturally rich in minerals that come from geothermal vents in the ocean floor. We slowly dry the kelp to protect iodine’s bioavailability.",
          },
          {
            title: "The Research",
            text: "Clinically shown to provide minerals essential to hair growth.",
          },
        ],
      },
      {
        name: "Pea Sprout Extract",
        image: INGREDIENTS_IMAGES.PEA_SPROUT,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "This concentrated extract is clinically shown to improve hair growth.",
          },
        ],
      },
      {
        name: "Sea Buckthorn",
        image: INGREDIENTS_IMAGES.SEA_BUCKTHORN,
        target: "Anti-breakage",
        items: [
          {
            title: "What It Is",
            text: "A nutrient-rich oil that promotes skin and scalp health by supporting hydration and replenishing moisture.",
          },
        ],
      },
    ],
  },
  editorial: {
    verticalSpacing: ["64px", "80px", "128px"],
    mobilePadding: "66.66%",
    image: pdpEditorialImagePostpartum,
    imageTablet: pdpEditorialImagePostpartum,
    imageMobile: pdpEditorialImagePostpartum,
    slides: [
      {
        abbreviation: "Tc",
        icon: INGREDIENTS_IMAGES.SHATAVARI,
        title: "Shatavari",
        text: "An adaptogen that counters stress hormones and supports female reproductive health.<sup>10</sup>",
      },
      {
        abbreviation: "Sp",
        icon: INGREDIENTS_IMAGES.OMEGAS,
        title: "DHA Omega-3s",
        text: "Support healthy immune and stress responses, which are essential for your hair growth.<sup>11</sup>",
      },

      {
        abbreviation: "Sa",
        title: "Apple Polyphenols",
        icon: INGREDIENTS_IMAGES.APPLE,
        text: "An antioxidant high in polyphenols to support hair growth.<sup>12</sup>",
      },
    ],
    button: {
      label: "See all 21 ingredients",
      destination: `/ingredients/`,
      isTextLink: true,
      module_location: "bottom_fold",
    },
  },
  ingredients: {
    title: "Supporting Ingredients",
    list: [
      "Vitamin A",
      "Vitamin C",
      "Vitamin D",
      "Vitamin B1",
      "Vitamin B2",
      "Vitamin B3",
      "Vitamin B5",
      "Vitamin B6",
      "Biotin",
      "Vitamin B9",
      "Vitamin B12",
      "Selenium",
      "Zinc",
      "L-Cysteine",
      "L-Methionine",
      "L-Lysine",
    ],
  },
}

export const Men = {
  core: "Men",
  dropdownImg: PRODUCT_IMAGES.MENPRO1.label1,
  name: "Men",
  info: "For men 18+",
  complex: {
    title: "Synergen Complex&reg;",
    list: [
      {
        name: "Sensoril&reg; Ashwagandha",
        image: INGREDIENTS_IMAGES.ASHWAGANDHA,
        target: "Anti Shedding",
        items: [
          {
            title: "What It Is",
            text: "An adaptogen that helps balance stress hormones to support a healthy hair growth cycle.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Exclusive to Nutrafol, Sensoril® Ashwagandha is wild-harvested in India using sustainable practices and a double-patented clean extraction method. Sensoril® is the highest quality Ashwagandha available in a hair supplement. While most Ashwagandha extracts come from the root of the plant, ours is extracted from the root and leaves for a higher concentration of actives that absorbs more quickly and easily into the body.",
          },
          {
            title: "The Research",
            text: "More than 12 clinical trials have shown proven benefits for stress relief, immune support, sleep quality, fatigue, and energy.",
          },
        ],
      },
      {
        name: "Saw Palmetto",
        image: INGREDIENTS_IMAGES.SAW_PALMETTO,
        target: "Anti-DHT",
        items: [
          {
            title: "What It Is",
            text: "Saw Palmetto promotes hair growth by helping reduce DHT, a hormone that shrinks hair follicles and leads to progressive hair thinning.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Our Saw Palmetto is responsibly harvested in the USA and extracted through a non-toxic, high-pressure process for the highest concentration of plant actives in each batch. The extract delivers efficacy to areas of the body like the scalp to help improve hair growth.",
          },
          {
            title: "The Research",
            text: "Our Saw Palmetto has been shown in over 25 clinical trials to improve urinary tract health and support hair health.",
          },
        ],
      },
      {
        name: "Tocotrienol Complex",
        image: INGREDIENTS_IMAGES.TOCOTRIENOL,
        target: "Densifying",
        items: [
          {
            title: "What It Is",
            text: "This concentrated form of the antioxidant vitamin E helps minimize the effects of environmental stress to improve hair density.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sourced from sustainably grown palm trees grown in renewable land in Malaysia, our oil is extracted from palm seeds then optimized for superior absorption in the body.",
          },
          {
            title: "The Research",
            text: "With over 20 years of research, this is the only Tocotrienol Extract that’s clinically proven for hair growth.",
          },
        ],
      },
      {
        name: "Marine Collagen Peptides",
        image: INGREDIENTS_IMAGES.MARINE_COLLAGEN,
        target: "Strengthening",
        items: [
          {
            title: "What It Is",
            text: "Peptides provide the building blocks of strong hair and deliver moisture to the scalp.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Sustainably sourced from wild-caught fish that live in the cleanest ocean waters of the North Atlantic, then upcycled from the scales of the fish. Our Marine Collagen Peptides are processed to be a specific size that the body can absorb quickly and use immediately to support healthy hair.",
          },
          {
            title: "The Research",
            text: "Clinical studies have shown that improved bioactivity of collagen increases collagen stores in the body for healthy hair and skin support.",
          },
        ],
      },
      {
        name: "Curcumin",
        image: INGREDIENTS_IMAGES.CURCUMIN,
        target: "Multi-targeting",
        items: [
          {
            title: "What It Is",
            text: "An active ingredient found in turmeric, this supercharged antioxidant addresses multiple root causes of hair thinning and is 500x more potent than turmeric alone.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Traditionally and organically harvested to minimize environmental waste. We use a patented extraction method that extends the length of Curcumin’s bioactivity in the body, which allows it time to effectively target root causes of hair thinning.",
          },
          {
            title: "The Research",
            text: "Proven in over 28 clinical studies to benefit multiple systems in the body that affect the cellular response needed for hair growth.",
          },
        ],
      },
    ],
  },
  keyActives: {
    title: "Other Key Actives",
    list: [
      {
        name: "Kelp Minerals",
        image: INGREDIENTS_IMAGES.KELP,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "A sea vegetable that supports key hormones needed to promote a healthy metabolism for hair health.",
          },
          {
            title: "What Sets Ours Apart",
            text: "Wild-harvested from organic seaweed beds found in the pristine waters surrounding Iceland. This kelp is naturally rich in minerals that come from geothermal vents in the ocean floor. We slowly dry the kelp to protect iodine’s bioavailability.",
          },
          {
            title: "The Research",
            text: "Clinically shown to provide minerals essential to hair growth.",
          },
        ],
      },
      {
        name: "Resveratrol",
        image: INGREDIENTS_IMAGES.RESVERATROL,
        target: "Protecting",
        items: [
          {
            title: "What It Is",
            text: "Typically found in red wine, this powerful antioxidant promotes hair density by protecting the scalp from environmental damage. Ours is a bioavailable form derived from Japanese Knotweed.",
          },
        ],
      },
      {
        name: "Horsetail",
        image: INGREDIENTS_IMAGES.HORSETAIL,
        target: "Anti-breakage",
        items: [
          {
            title: "What It Is",
            text: "A natural source of silica, an essential mineral that promotes hair strength.",
          },
        ],
      },
      {
        name: "Keratin",
        image: INGREDIENTS_IMAGES.KERATIN,
        target: "Strengthening",
        items: [
          {
            title: "What It Is",
            text: "A protein that creates the structure for hair, skin, and nails. Our ingredient mimics keratin in the body to support damaged hair.",
          },
        ],
      },
    ],
  },
  editorial: {
    verticalSpacing: ["64px", "80px", "128px"],
    mobilePadding: "66.66%",
    image: pdpEditorialImageMen,
    imageTablet: pdpEditorialImageMen,
    imageMobile: pdpEditorialImageMen,
    slides: [
      {
        abbreviation: "Sp",
        icon: INGREDIENTS_IMAGES.SAW_PALMETTO,
        title: "Saw Palmetto",
        text: "Combats thinning hair by helping prevent testosterone conversion to DHT.<sup>9</sup>",
      },
      {
        abbreviation: "Tc",
        icon: INGREDIENTS_IMAGES.TOCOTRIENOL,
        title: "Tocotrienol Complex",
        text: "Improves hair density by lowering oxidative stress from the environment.<sup>6</sup>",
      },
      {
        abbreviation: "Sa",
        title: "Curcumin",
        icon: INGREDIENTS_IMAGES.CURCUMIN,
        text: "A highly active antioxidant that targets imbalances in the body to support healthy hair.<sup>13</sup>",
      },
    ],
    button: {
      label: "See all 21 ingredients",
      destination: `/ingredients/`,
      isTextLink: true,
      module_location: "bottom_fold",
    },
  },
  ingredients: {
    title: "Supporting Ingredients",
    list: [
      "L-Cysteine",
      "L-Lysine",
      "L-Methionine",
      "Black Pepper",
      "Capsicum",
      "Vitamin A",
      "Vitamin C",
      "Vitamin D",
      "Biotin ",
      "Zinc",
      "Selenium",
      "Hyaluronic Acid",
    ],
  },
}

export const ingredients_fb = [Women, Vegan, Balance, Postpartum, Men]
